const isInViewPort = (el) => {
    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

document.onscroll = () => {
    const steps = document.getElementById('wizard-steps');
    const scrollTopEl = document.getElementById('scrollTop');
    if (isInViewPort(steps)) {
        scrollTopEl.classList.add('hidden');
    } else {
        scrollTopEl.classList.remove('hidden');
    }
}

window.activeSegment = "upload";
window.scrollToElement = function (elementId) {
    const activeSegment = window.activeSegment;
    const IS_ACTIVE = 'is-active';

    document.getElementById(`${activeSegment}-segment`).classList.remove(IS_ACTIVE);
    document.getElementById(`${elementId}-segment`).classList.add(IS_ACTIVE);
    window.activeSegment = elementId;

    const element = document.getElementById(elementId);
    element.scrollIntoView({ block: "start", behavior: "smooth" });
}

window.resetScroll = function () {
    const steps = document.getElementById('wizard-steps');
    steps.scrollIntoView({ block: "end", behavior: "smooth" });
}